export default __webpack_public_path__ + "static/media/copy-light-grey.16173a22.svg";